// ── helpers ───────────────────────────────────────────────────────────────────
export const fmt = (n, d = 3) => Number(n || 0).toFixed(d);
export const fmtA = (n) =>
  Number(n || 0).toLocaleString("en-PK", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
export const fmtDate = (d) =>
  new Date(d).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

export const balanceColor = (type) => {
  if (type === "payable")
    return { bg: "#FEF3C7", text: "#92400E", border: "#FCD34D" };
  if (type === "receivable")
    return { bg: "#DCFCE7", text: "#166534", border: "#86EFAC" };
  return { bg: "#F3F4F6", text: "#6B7280", border: "#D1D5DB" };
};
